import { AssetAttributes } from "./assetAttributes";
import { AssetComments } from "./assetComments";
import { AssetTags } from "./assetTags";
import { AssetFile } from "./assetFile";
import { AssetCardDetails } from "./assetCardDetails";

export class Asset{
    _id: string;
    assetId: string;
    name: string;
    relativePath: string;
    webViewUrl: string;
    attributes: AssetAttributes;
    comments: Array<AssetComments>;
    tags: Array<string> = new Array<string>();
    assetfiles: Array<AssetFile>;
    ratings: string;
    noOfRatings: number;
    avgRating: any;
    inform = false;
    isCompletelyUploaded: boolean;
    description: string;
    remixedFrom: string;
    remixes:Array<AssetCardDetails> = new Array<AssetCardDetails>();
    assetName ?= '';
}